import auth from './guest';
import collections from './collections'
import { collectionProfiles } from './collections';
import entities from './entities'
import { searchUsers, userNotes, basicInfo, get } from './profile'

import { leadershipTypes, roleTypes, addressTypes, countries, getPermission, getOptions } from './index'

import { upload } from './upload'


export default {
    ...auth,
    ...collections,
    ...entities,
    profile: {
        get,
        searchUsers,
        userNotes
    },
    upload,
    leadershipTypes,
    roleTypes,
    addressTypes,
    countries,
    getPermission,
    getOptions,
    collectionProfiles
}



// WEBPACK FOOTER //
// ./src/api/api_routes.js